<template>
  <div class="row" v-if="show">
    <div class="col-12">
      <form :data-table="nametable" id="js-save_bread">
        <input type="hidden" v-model="tableInfo.id" name="id" />
        <input
          type="hidden"
          name="_token"
          value="nXrUxLOd2FulYvqfEAHAzxnnknZ2X1MlxqoonzGp"
        />
        <div class="panel">
          <div class="panel-heading bg-primary p-2 text-white">
            <h3 class="panel-title">{{ nametable }} BREAD info</h3>
          </div>
          <div class="panel-body">
            <div class="row clearfix">
              <div class="col-md-6 form-group">
                <label for="name">Nombre de la tabla</label>
                <input
                  type="text"
                  class="form-control"
                  readonly="true"
                  name="name_table"
                  v-model="tableInfo.name_table"
                  disable
                />
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-6 form-group">
                <label for="email">Nombre para mostrar (Singular)</label>
                <input
                  type="text"
                  class="form-control"
                  name="display_name_singular"
                  placeholder="Nombre para mostrar (Singular)"
                  v-model="tableInfo.display_name_singular"
                  require
                />
              </div>
              <div class="col-md-6 form-group">
                <label for="email">Nombre para mostrar (Plural)</label>
                <input
                  type="text"
                  class="form-control"
                  name="display_name_plural"
                  placeholder="Nombre para mostrar (Plural)"
                  v-model="tableInfo.display_name_plural"
                  require
                />
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-6 form-group">
                <label for="email">URL Slug (tiene que ser único)</label>
                <input
                  type="text"
                  class="form-control"
                  name="slug"
                  v-model="tableInfo.slug"
                  placeholder="URL slug (ej. posts)"
                />
              </div>
              <div class="col-md-6 form-group">
                <label for="email">
                  Icono (opcional) a usar
                  <a
                    href="https://glyphsearch.com/?copy=class&library=font-awesome"
                    target="_blank"
                    >Font Awesome</a
                  >
                </label>
                <input
                  type="text"
                  class="form-control"
                  name="icon"
                  v-model="tableInfo.icon"
                  placeholder="Icono para usar en esta tabla"
                />
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-6 form-group">
                <label for="generate_permissions"
                  >Generar permisos (en desarrollo)</label
                >
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-6 form-group">
                <label for="description">Descripción</label>
                <input
                  class="form-control"
                  name="description"
                  v-model="tableInfo.description"
                  placeholder="Description"
                />
              </div>
              <div class="col-md-6 form-group">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="tableInfo.visible"
                    name="optionsRadios"
                    value="1"
                    :checked="tableInfo.visible == 1 ? 'true' : 'false'"
                  />
                  Sí
                </label>
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    v-model="tableInfo.visible"
                    name="optionsRadios"
                    value="2"
                    :checked="tableInfo.visible == 2 ? 'true' : 'false'"
                  />
                  No
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="panel">
        <div class="panel-heading bg-primary">
          <h3 class="panel-title text-white">{{ nametable }} BREAD info</h3>
          <hr />
          <div
            class="
              panel-subtitle
              bg-secondary
              text-white
              d-flex
              align-items-center
              p-1
            "
          >
            <div class="col-xs-2">Field</div>
            <div class="col-xs-2">Visibility</div>
            <div class="col-xs-2">Input Type</div>
            <div class="col-xs-2">Display Name</div>
            <div class="col-xs-4">Optional Details</div>
          </div>
          <br />
        </div>
        <div class="panel-body p-2">
          <div id="bread-items" class="ui-sortable">
            <form
              v-for="(v, index) in table"
              :key="index"
              class="form-bread"
              :id="'form-bread_' + index"
              :data-field="v.Field"
            >
              <div class="row row-dd ui-sortable-handle">
                <div class="col-xs-2">
                  <h4 class="text text__subtitle">
                    <strong>{{ v.Field }}</strong>
                  </h4>
                  <template v-if="v.Type">
                    <strong>Type:</strong>
                    <span>{{ v.Type }}</span>
                    <br />
                  </template>
                  <template v-if="v.Null">
                    <strong>Key:</strong>
                    <span>{{ v.Null }}</span>
                    <br />
                  </template>
                  <template v-if="v.Key">
                    <strong>Nulo:</strong>
                    <span>{{ v.Key }}</span>
                    <br />
                  </template>
                  <template v-if="v.Default">
                    <strong>Por defecto:</strong>
                    <span>{{ v.Default }}</span>
                    <br />
                  </template>
                  <template v-if="v.Extra">
                    <strong>Extra:</strong>
                    <span>{{ v.Extra }}</span>
                    <br />
                  </template>
                </div>
                <div class="col-xs-2">
                  <label>
                    <input
                      type="checkbox"
                      :name="'field_thead_' + index"
                      :checked="field.data[index + 1].visibility.thead"
                    />Mostrar en tabla
                  </label>
                  <br />
                  <label>
                    <input
                      type="checkbox"
                      :name="'field_edit_' + index"
                      :checked="field.data[index + 1].visibility.edit"
                    />Edición
                  </label>
                  <br />
                </div>
                <div class="col-xs-2">
                  <select
                    :name="'input_type_' + index"
                    v-model="field.data[index + 1].type"
                  >
                    <option value="text">Text</option>
                    <option value="number">Numérico</option>
                    <option value="select">Select</option>
                    <option value="select_multiple">Select Multiple</option>
                    <option value="date">Fecha</option>
                    <option value="checkbox">Checkbox</option>
                    <option value="textarea">Textarea</option>
                    <option value="texto_enriquecido">Texto enriquecido</option>
                    <option value="image">Imagen</option>
                    <option value="file">Archivo</option>
                    <option value="switch">Switch</option>
                  </select>
                </div>
                <div class="col-xs-2">
                  <input
                    type="text"
                    class="form-control"
                    :name="'display_name_' + index"
                    v-model="field.data[index + 1].name"
                  />
                </div>
                <div class="col-xs-4">
                  <textarea
                    :name="'field_options_' + index"
                    :id="'field_options_' + index"
                    cols="10"
                    rows="6"
                  >
                                        {{
                      field.data[index + 1].options
                        ? getJSONOptions(field.data[index + 1].options)
                        : false
                    }}
                                    </textarea
                  >
                </div>
              </div>
              <hr />
            </form>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="box-footer">
      <button
        type="submit"
        :data-table="nametable"
        @click.prevent="save"
        class="btn btn-primary"
      >
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
export default {
  name: "editbread",
  props: ["nametable", "table", "field", "tableInfo", "showForm"],
  components: {
    VueEditor,
  },
  created() {
    setTimeout(() => {
      this.tableInfo.name_table = this.field.data[0];
      this.show = true;
    }, 1000);
  },
  data() {
    return {
      customToolbar: [["code"]],
      show: false,
    };
  },
  methods: {
    selected(a) {
      return a;
    },
    getJSONOptions(a) {
      if (a) {
        return a[0];
      }
    },
    save() {
      this.$parent.$emit("parentSave");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/forms/editbread.vue